/**
 * @providesModule EditProfileScreenStyle
 */

import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import {Platform, StyleSheet} from 'react-native';

const {
  btnTextColorOne,
  fontBold,
  fontPrimaryItalic,
  fontPrimary,
  fontSecondary,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  textColorCash,
  textColorPrimary,
  textColorSecondary,
  textColorTertiary,
  textColorTicketz,
  textColorZ,
  viewBorderWidthTertiary,
  viewCornerRadiusPrimary,
  viewCornerRadiusTertiary,
  viewDividerColorTwo,
  viewPrimaryColor,
  viewSecondaryColor,
  viewTertiaryColor,
} = SkillzStyle.fullStyles;

const IOS_NAV_BAR_HEIGHT = Sizes.select({
  portrait: 44,
  landscapeTablet: 44,
  landscapePhone: 32,
});

const BaseInputFormStyles = {
  formFieldFontSize: Sizes.select({
    medium: 14,
    large: 15,
  }),
};

export default StyleSheet.create({
  avatarChangeIcon: {
    ...Sizes.select({
      phone: {
        height: 27,
        width: 27,
      },
      tablet: {
        height: 36,
        width: 36,
      },
    }),
    margin: 2,
  },

  avatarImage: {
    ...Sizes.select({
      portraitPhone: {
        height: 124,
        width: 124,
      },
      landscapePhone: {
        height: 100,
        width: 100,
      },
      portraitTablet: {
        height: 170,
        width: 170,
      },
      landscapeTablet: {
        height: 160,
        width: 160,
      },
    }),
    position: 'absolute',
  },

  avatarImageV2: {
    ...Sizes.select({
      portraitPhone: {
        height: 143,
        width: 143,
        borderRadius: 75,
      },
      landscapePhone: {
        height: 100,
        width: 100,
        borderRadius: 50,
      },
      portraitTablet: {
        height: 170,
        width: 170,
        borderRadius: 85,
      },
      landscapeTablet: {
        height: 160,
        width: 160,
        borderRadius: 80,
      },
    }),
    position: 'absolute',
    overflow: 'hidden',
  },

  avatarContainer: {
    ...Sizes.select({
      portraitPhone: {
        height: 124,
        width: 124,
        marginBottom: 20,
      },
      landscapePhone: {
        height: 100,
        width: 100,
        marginBottom: 4,
      },
      portraitTablet: {
        height: 170,
        width: 170,
        marginBottom: 36,
      },
      landscapeTablet: {
        height: 160,
        width: 160,
        marginBottom: 6,
      },
    }),
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    borderRadius: 6,
    overflow: 'hidden',
  },

  avatarContainerV2: {
    ...Sizes.select({
      portraitPhone: {
        height: 150,
        width: 150,
        borderRadius: 79,
        marginBottom: 20,
      },
      landscapePhone: {
        height: 100,
        width: 100,
        marginBottom: 4,
        borderRadius: 50,
      },
      portraitTablet: {
        height: 170,
        width: 170,
        marginBottom: 36,
        borderRadius: 85,
      },
      landscapeTablet: {
        height: 160,
        width: 160,
        marginBottom: 6,
        borderRadius: 80,
      },
    }),
    backgroundColor: '#D9D9D9',
    alignItems: 'center',
    justifyContent: 'center',
  },

  backButtonContent: {
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: 0,
  },

  backButtonTouchable: {
    flexDirection: 'row',
    flexGrow: 1,
  },

  buttonView: {
    height: IOS_NAV_BAR_HEIGHT,
    justifyContent: 'center',
  },

  centerContent: {
    ...Sizes.orientation({portrait: {}, landscape: {marginVertical: 8}}),
    alignSelf: 'stretch',
    justifyContent: 'space-around',
    ...Sizes.select({
      smallPortraitPhone: {
        maxHeight: 320,
      },
      mediumPortraitPhone: {},
      other: {},
    }),
    backgroundColor: '#FFFFFF',
    borderRadius: 6,
  },

  centerContentV2: {
    ...Sizes.orientation({portrait: {}, landscape: {marginVertical: 8}}),
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'space-around',
    ...Sizes.select({
      smallPortraitPhone: {
        maxHeight: 320,
      },
      mediumPortraitPhone: {},
      other: {},
    }),
    borderRadius: 6,
  },

  nextButtonV2: {
    borderRadius: 100,
    backgroundColor: '#4990E8',
    width: '50%',
    alignSelf: 'center',
    marginBottom: 10,
    alignContent: 'center',
    justifyContent: 'center',
  },

  signInButtonV2: {
    width: '50%',
    alignSelf: 'center',
    marginVertical: 10,
  },

  matchCodeTextContainer: {
    ...Sizes.select({
      portraitTablet: {
        ...fontSizeH3,
      },
      other: {},
    }),
    color: Platform.select({
      android: 'black',
    }),
  },

  centerAnimationContainer: {
    alignItems: 'center',
    alignSelf: Sizes.select({portraitPhone: 'stretch', other: 'center'}),
  },

  centerContentContainer: {
    ...viewTertiaryColor,
    ...viewCornerRadiusPrimary,
    ...Sizes.select({
      smallPhone: {marginHorizontal: 30},
      largePhone: {marginHorizontal: 56},
      landscapePhone: {width: 212},
      portraitTablet: {width: 360},
      landscapeTablet: {width: 320},
    }),
    alignItems: 'center',
    alignSelf: Sizes.select({portraitPhone: 'stretch', other: 'center'}),
  },

  centerContentContainerV2: {
    ...viewCornerRadiusPrimary,
    alignItems: 'center',
    justifyContent: 'space-around',
    alignSelf: Sizes.select({portraitPhone: 'stretch', other: 'center'}),
  },

  footerCenterContainerButton: {
    ...viewBorderWidthTertiary,
    ...viewCornerRadiusPrimary,
    ...Sizes.select({
      portraitPhone: {
        height: 36,
        width: 302,
        marginHorizontal: 56,
      },
      largeLandscapePhone: {
        height: 28,
        width: 140,
        marginHorizontal: 8,
      },
      smallLandscapePhone: {
        height: 24,
        width: 140,
        marginHorizontal: 8,
      },
      portraitTablet: {
        height: 50,
        width: 360,
        marginHorizontal: 8,
      },
      landscapeTablet: {
        height: 42,
        width: 200,
        marginHorizontal: 12,
      },
    }),
    borderColor: textColorPrimary.color,
    alignItems: 'center',
    justifyContent: 'center',
  },

  changeMessage: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({phone: fontSizeH5, tablet: fontSizeH4}),
    textAlign: 'center',
    textAlignVertical: 'center',

    marginTop: -12,
    marginHorizontal: 16,

    marginBottom: Sizes.select({
      portraitPhone: 20,
      landscapePhone: 4,
      portraitTablet: 24,
      landscapeTablet: 6,
    }),
  },

  changeMessageV2: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({phone: {fontSize: 18}, tablet: fontSizeH3}),
    textAlign: 'center',
    textAlignVertical: 'center',

    marginTop: -12,
    marginHorizontal: 16,

    marginBottom: Sizes.select({
      portraitPhone: 20,
      landscapePhone: 4,
      portraitTablet: 24,
      landscapeTablet: 6,
    }),
  },

  detailMessage: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({phone: fontSizeH5, tablet: fontSizeH4}),
    textAlign: 'center',
    textAlignVertical: 'center',

    marginTop: -12,
    marginHorizontal: 16,

    marginBottom: Sizes.select({
      portraitPhone: 15,
      landscapePhone: 4,
      portraitTablet: 24,
      landscapeTablet: 6,
    }),
  },

  changeUsername: {
    ...viewBorderWidthTertiary,
    ...viewCornerRadiusPrimary,
    ...viewSecondaryColor,
    ...fontSecondary,
    ...textColorSecondary,
    ...Sizes.select({
      portraitPhone: {
        ...fontSizeH3,
        marginBottom: 40,
        marginHorizontal: 16,
        height: 45,
      },
      landscapePhone: {
        ...fontSizeH4,
        marginBottom: 4,
        height: 28,
        marginHorizontal: 28,
      },
      portraitTablet: {
        ...fontSizeH2,
        marginBottom: 24,
        height: 48,
        marginHorizontal: 48,
      },
      landscapeTablet: {
        ...fontSizeH2,
        marginBottom: 6,
        height: 44,
        marginHorizontal: 44,
      },
    }),
    alignSelf: 'stretch',
    borderColor: textColorTertiary.color,
    textAlign: 'center',
    padding: 0,
    flex: 1,
  },

  changeUsernameWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },

  changeUsernameV2: {
    ...fontPrimary,
    ...textColorSecondary,
    ...fontSizeH4,
    fontWeight: '600',
    textAlign: 'left',
    flex: 1,
    marginHorizontal: 20,
    ...Platform.select({
      web: {
        width: '100%',
        height: '100%',
        outlineStyle: 'none',
      },
    }),
  },

  changeUsernameContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  changeUsernameContainerV2: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'white',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowRadius: 6,
    shadowOpacity: 0.15,
    elevation: 8,
    backgroundColor: 'white',
    ...Sizes.select({
      phone: {
        ...Platform.select({
          ios: fontSizeH3,
          android: {fontSize: fontSizeH3.fontSize - 1},
        }),
        marginHorizontal: 16,
        height: 56,
        width: '80%',
        borderRadius: 100,
        marginBottom: 16,
        marginTop: -4,
      },
      tablet: {
        ...fontSizeH1,
        marginBottom: 20,
        height: 64,
        borderRadius: 100,
        marginHorizontal: 40,
      },
    }),
  },

  refreshButtonContainer: {
    position: 'absolute',
    zIndex: 1,
  },

  refreshButtonContainerV2: {
    zIndex: 1,
    right: 12,
  },

  editAvatarButtonsContainer: {
    position: 'absolute',
    top: 2,
    bottom: 2,
    left: 2,
    right: 2,
    zIndex: 1,
  },

  refreshButtonIcon: {
    width: 20,
    height: Platform.OS === 'web' ? 15 : 20,
  },

  refreshButtonIconV2: {
    width: 18,
    height: Platform.OS === 'web' ? 13 : 18,
  },

  editButtonIconV2: {
    width: 16,
    height: Platform.OS === 'web' ? 13 : 16,
  },

  refreshAvatarIcon: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    width: 24,
    height: 24,
    borderRadius: 16,
    backgroundColor: 'white',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    elevation: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },

  refreshAvatarIconV2: {
    position: 'absolute',
    bottom: -2,
    right: -2,
    width: 30,
    height: 30,
    borderRadius: 16,
    backgroundColor: 'white',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    elevation: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },

  editAvatarIcon: {
    position: 'absolute',
    top: 2,
    right: 2,
    width: 24,
    height: 24,
    borderRadius: 16,
    backgroundColor: 'white',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 8,
  },

  editAvatarIconV2: {
    position: 'absolute',
    top: -2,
    right: -2,
    width: 30,
    height: 30,
    borderRadius: 16,
    backgroundColor: 'white',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowRadius: 6,
    shadowOpacity: 0.3,
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 8,
  },

  confirmProfileJoinEvent: {
    ...fontPrimary,
    ...fontSizeH3,
    ...textColorPrimary,
    marginRight: 50,
  },

  createProfileHeading: {
    ...viewSecondaryColor,
    height: Sizes.select({phone: 50, tablet: 80}),
    alignSelf: 'stretch',
    borderTopLeftRadius: viewCornerRadiusPrimary.borderRadius,
    borderTopRightRadius: viewCornerRadiusPrimary.borderRadius,
    alignItems: 'center',
    justifyContent: 'center',
  },

  createProfileHeadingIcon: {
    ...Sizes.select({
      phone: {
        height: 42,
        width: 42,
        borderRadius: 6,
      },
      tablet: {
        height: 60,
        width: 60,
        borderRadius: 10,
      },
    }),
    marginHorizontal: 8,
    resizeMode: 'contain',
  },

  createProfileHeadingName: {
    ...fontSecondary,
    ...textColorSecondary,
    ...Sizes.select({phone: fontSizeH4, tablet: fontSizeH3}),
    maxWidth: '85%',
  },

  createProfileHeadingWrapper: {
    flexDirection: 'row',
    maxWidth: '100%',
    alignItems: 'center',
    marginTop: Sizes.select({phone: 8, tablet: 10}),
  },

  confirmProfileHeading: {
    maxWidth: '85%',
    flexDirection: 'column',
  },

  confirmProfileHeadingName: {
    ...fontPrimary,
    ...fontSizeH3,
    ...textColorSecondary,
    textAlign: 'center',
  },

  confirmProfileHeadingNotStarting: {
    ...fontBold,
    ...fontSizeH3,
    ...textColorSecondary,
    textAlign: 'center',
  },

  confirmProfileTournamentName: {
    ...fontBold,
    ...fontSizeH3,
    ...textColorSecondary,
    textAlign: 'center',
  },

  divider: {
    ...viewDividerColorTwo,
    height: 1,
    marginHorizontal: Sizes.select({phone: 32, tablet: 44}),
    alignSelf: 'stretch',
  },

  existingAccountLabelV2: {
    ...fontPrimary,
    ...fontSizeH5,
    ...textColorSecondary,
    textAlign: 'center',
  },

  footerBarButton: {
    ...viewBorderWidthTertiary,
    ...viewCornerRadiusPrimary,
    ...Sizes.select({
      portraitPhone: {
        height: 36,
        width: 140,
      },
      largeLandscapePhone: {
        height: 28,
        width: 140,
        marginHorizontal: 8,
      },
      smallLandscapePhone: {
        height: 24,
        width: 140,
        marginHorizontal: 8,
      },
      portraitTablet: {
        height: 50,
        width: 200,
        marginHorizontal: 8,
      },
      landscapeTablet: {
        height: 42,
        width: 200,
        marginHorizontal: 12,
      },
    }),
    borderColor: textColorPrimary.color,
    alignItems: 'center',
    justifyContent: 'center',
  },

  footerBarButtonText: {
    ...fontPrimary,
    ...textColorPrimary,
    ...Sizes.select({tablet: fontSizeH2, phone: fontSizeH4}),
    textAlign: 'center',
    textAlignVertical: 'center',
  },

  liveEventCodeUnderline: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({tablet: fontSizeH2, phone: fontSizeH4}),
    textAlign: 'center',
    textDecorationLine: 'underline',
    textAlignVertical: 'center',
    marginTop: 10,
  },
  liveEventCodeSubtext: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({tablet: fontSizeH2, phone: fontSizeH4}),
    textAlign: 'center',
    textAlignVertical: 'center',
    marginTop: 4,
  },

  footerBarContainer: {
    ...viewPrimaryColor,
    borderTopWidth: viewBorderWidthTertiary.borderWidth,
    borderColor: textColorPrimary.color,
    justifyContent: Sizes.select({portraitPhone: 'space-around', other: 'center'}),
    height: Sizes.select({
      smallPhone: 60,
      smallLandscapePhone: 40,
      largeLandscapePhone: 52,
      other: 90,
    }),
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },

  footerBarContainerV2: {
    justifyContent: Sizes.select({portraitPhone: 'space-around', other: 'center'}),
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'flex-end',
    marginTop: 10,
  },

  headerBarContainer: {
    ...viewPrimaryColor,
    borderBottomWidth: viewBorderWidthTertiary.borderWidth,
    borderColor: textColorPrimary.color,
    height: Sizes.select({phone: 48, tablet: 64}),
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
  },

  headerBarContainerLandscape: {
    ...viewPrimaryColor,
    borderBottomWidth: viewBorderWidthTertiary.borderWidth,
    borderColor: textColorPrimary.color,
    height: Sizes.select({
      smallPhone: 40,
      largePhone: 70,
      tablet: 96,
    }),
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  landscapeHeaderAppIcon: {
    ...Sizes.select({
      largePhone: {
        height: 60,
        width: 60,
        borderRadius: 10,
      },
      smallPhone: {
        height: 32,
        width: 32,
        borderRadius: 5,
      },
      tablet: {
        height: 72,
        width: 72,
        borderRadius: 12,
      },
    }),
    resizeMode: 'contain',
    marginHorizontal: 10,
  },

  landscapeHeaderAppInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  landscapeHeaderAppName: {
    ...Sizes.select({phone: fontSizeH3, tablet: fontSizeH2}),
    ...fontSecondary,
    ...textColorPrimary,
  },

  mainContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  mainContainerV2: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    position: 'absolute',
    backgroundColor: 'rgba(255,255,255,1)',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingBottom: 40,
    paddingTop: 40,
  },

  nameAndAvatarContainer: {
    flexGrow: 1,
    alignItems: 'center',
    marginVertical: Sizes.select({
      portraitPhone: 16,
      landscapePhone: 4,
      portraitTablet: 28,
      landscapeTablet: 8,
    }),
  },

  nextButton: {
    ...Sizes.select({
      portraitPhone: {
        height: 36,
        marginHorizontal: 16,
        marginVertical: 20,
      },
      landscapePhone: {
        height: 28,
        marginHorizontal: 40,
        marginVertical: 4,
      },
      portraitTablet: {
        height: 48,
        marginHorizontal: 48,
        marginVertical: 32,
      },
      landscapeTablet: {
        height: 42,
        marginHorizontal: 60,
        marginVertical: 6,
      },
    }),
    alignSelf: 'stretch',
    marginTop: -36,
  },

  nextButtonText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.select({
      portraitPhone: fontSizeH2,
      landscapePhone: fontSizeH3,
      tablet: fontSizeH1,
    }),
  },

  pickInfoTitle: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({
      portraitPhone: fontSizeH3,
      landscapePhone: fontSizeH4,
      tablet: fontSizeH2,
    }),
    textAlign: 'center',
    textAlignVertical: 'center',
    marginBottom: Sizes.select({
      portraitPhone: 16,
      landscapePhone: 4,
      portraitTablet: 24,
      landscapeTablet: 6,
    }),
  },

  pickInfoTitleV2: {
    ...fontBold,
    ...textColorSecondary,
    ...Sizes.select({
      portraitPhone: {fontSize: 22},
      landscapePhone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    textAlign: 'center',
    textAlignVertical: 'center',
    marginBottom: Sizes.select({
      portraitPhone: 18,
      landscapePhone: 4,
      portraitTablet: 24,
      landscapeTablet: 6,
    }),
  },

  skillzPowered: {
    width: 60,
    height: 36,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 12,
    marginBottom: 4,
  },

  skillzPoweredV2: {
    width: 120,
    height: 76,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 12,
  },

  skillzPoweredS: {
    width: 32,
    height: 32,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 12,
    marginBottom: -12,
  },

  skillzPoweredText: {
    ...textColorPrimary,
    fontFamily: Platform.select({
      ios: 'SuiGenerisRg-Regular',
      android: 'SuiGeneris',
    }),
    textAlign: 'center',
    textAlignVertical: 'center',
    backgroundColor: 'transparent',
  },

  skillzPoweredBottom: {
    fontSize: 12,
  },

  skillzPoweredTop: {
    ...Platform.select({
      ios: {marginBottom: -6},
      android: {},
    }),
    fontSize: 24,
  },

  zCurrency: {
    ...fontSecondary,
    ...textColorZ,
    ...fontSizeH3,
    textAlign: 'center',
  },

  cashCurrency: {
    ...fontSecondary,
    ...textColorCash,
    ...fontSizeH3,
    textAlign: 'center',
  },

  ticketzView: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },

  ticketzImage: {
    marginRight: 2,
    alignSelf: 'center',
    height: Sizes.select({
      portraitPhone: 18,
      smallLandscapePhone: 15,
      landscapePhone: 18,
      portraitTablet: 18,
      landscapeTablet: Sizes.isAndroidSmallLandscapeTablet() ? 18 : 30,
    }),
    width: Sizes.select({
      portraitPhone: 18,
      smallLandscapePhone: 15,
      landscapePhone: 18,
      portraitTablet: 18,
      landscapeTablet: Sizes.isAndroidSmallLandscapeTablet() ? 18 : 30,
    }),
  },

  ticketzCurrency: {
    ...fontSecondary,
    ...textColorTicketz,
    ...fontSizeH3,
    textAlign: 'center',
  },

  staticWarningTitle: {
    ...fontSecondary,
    ...textColorSecondary,
    ...fontSizeH3,
    marginBottom: 10,
  },

  staticMessageText: {
    ...textColorSecondary,
    ...fontSizeH4,
    marginBottom: 20,
    paddingHorizontal: 25,
    textAlign: 'center',
  },

  staticButtonText: {
    ...fontSecondary,
    ...textColorPrimary,
    ...fontSizeH4,
  },

  staticCTAButton: {
    width: 240,
    height: 35,
  },

  countrySelectionAnimationWrapper: {
    marginHorizontal: 16,
    marginBottom: 16,
  },

  countrySelectionAnimationContainer: {
    aspectRatio: 231 / 118,
    width: '100%',
  },

  fieldWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 16,
    marginBottom: 40,
  },

  formField: {
    backgroundColor: 'transparent',
    borderColor: '#999999',
    borderRadius: 4,
    borderWidth: 1,
    flex: 1,
    marginHorizontal: 5,
    height: 50,
    marginVertical: 5,
    justifyContent: 'center',
  },
  countryTextContainer: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    paddingLeft: 10,
    paddingTop: Sizes.select({
      medium: 5,
      large: 3,
    }),
    height: 50,
    flex: 1,
  },

  countryPickerHeaderText: {
    fontFamily: 'Helvetica',
    fontSize: BaseInputFormStyles.formFieldFontSize,
    ...textColorTertiary,
    textAlign: 'center',
  },

  countryPickerLabelText: {
    fontFamily: 'Helvetica',
    fontSize: BaseInputFormStyles.formFieldFontSize,
    ...textColorSecondary,
    textAlign: 'center',
    marginTop: Platform.select({
      ios: 5,
      android: 15,
    }),
    marginLeft: Platform.select({
      android: 2,
    }),
  },

  downArrow: {
    width: 10,
    height: 20,
    alignSelf: 'center',
    marginRight: 18,
  },

  androidCountryPickerContainer: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },

  centerCTAContainer: {
    ...Sizes.select({
      smallPhone: {marginHorizontal: 32},
      largePhone: {marginHorizontal: 32},
      landscapePhone: {width: 212},
      portraitTablet: {width: 360},
      landscapeTablet: {width: 320},
    }),
    alignItems: 'center',
    alignSelf: Sizes.select({portraitPhone: 'stretch', other: 'center'}),
  },

  centerCTAContainerArrowPadding: {
    marginTop: 20,
    marginBottom: 10,
  },

  centerCTAContainerNoArrow: {
    top: -10,
  },

  termsAndServiceText: {
    marginTop: 10,
    ...fontPrimary,
    ...Sizes.select({
      phone: fontSizeH5,
      tablet: fontSizeH4,
    }),
    textAlign: 'center',
    color: '#000',
  },

  termsAndServiceTextV2: {
    ...fontPrimary,
    ...Sizes.select({
      phone: fontSizeH5,
      tablet: fontSizeH4,
    }),
    textAlign: 'center',
    ...textColorSecondary,
  },

  termsAndServiceSubText: {
    textDecorationLine: 'underline',
    ...textColorSecondary,
  },

  termsOfUseContainer: {
    height: Sizes.screenHeight - 100,
    width: Sizes.screenWidth,
  },
});

export const EditStyle = StyleSheet.create({
  avatarChangeIcon: {
    ...Sizes.select({
      phone: {
        height: 30,
        width: 30,
      },
      tablet: {
        height: 40,
        width: 40,
      },
    }),
  },

  avatarContainer: {
    ...Sizes.select({
      phone: {
        height: 124,
        width: 124,
        marginBottom: 24,
      },
      tablet: {
        height: 170,
        width: 170,
        marginBottom: 30,
      },
    }),
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },

  avatarImage: {
    ...Sizes.select({
      phone: {
        height: 125,
        width: 125,
      },
      tablet: {
        height: 170,
        width: 170,
      },
    }),
    position: 'absolute',
    marginTop: -6,
  },

  centerContentContainer: {
    ...viewTertiaryColor,
    ...viewCornerRadiusPrimary,
    ...Sizes.select({
      phone: {marginHorizontal: 51.5}, // width: 200px
      tablet: {width: 360},
    }),
    alignItems: 'center',
    alignSelf: Sizes.select({portraitPhone: 'stretch', other: 'center'}),
  },

  changeMessageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexGrow: 1,
    ...Platform.select({
      ios: {
        marginHorizontal: 39,
        marginTop: -5,
      },
      android: {
        marginHorizontal: 36,
      },
    }),
    ...Sizes.select({
      phone: {
        height: 40,
        marginBottom: 15,
      },
      tablet: {
        marginHorizontal: 24,
        height: 50,
        marginBottom: 15,
      },
    }),
  },

  changeUsername: {
    ...viewBorderWidthTertiary,
    ...viewCornerRadiusTertiary,
    ...viewSecondaryColor,
    ...fontSecondary,
    ...textColorSecondary,
    ...Sizes.select({
      phone: {
        ...Platform.select({
          ios: fontSizeH3,
          android: {fontSize: fontSizeH3.fontSize - 1},
        }),
        marginHorizontal: 16,
        height: 45,
        marginBottom: 16,
        marginTop: -4,
      },
      tablet: {
        ...fontSizeH1,
        marginBottom: 20,
        height: 48,
        marginHorizontal: 40,
      },
    }),
    paddingRight: 5,
    alignSelf: 'stretch',
    borderColor: textColorTertiary.color,
    textAlign: 'center',
    padding: 0,
    flex: 1,
  },

  divider: {},

  nameAndAvatarContainer: {
    flexGrow: 1,
    alignItems: 'center',
    marginTop: Sizes.select({
      phone: 16,
      tablet: 20,
    }),
  },

  nextButton: {
    ...Sizes.select({
      phone: {
        height: 35,
        paddingHorizontal: 16,
        marginHorizontal: 16,
        marginTop: 5,
        marginBottom: 22,
      },
      tablet: {
        height: 48,
        marginHorizontal: 41,
        marginTop: 10,
        marginBottom: 32,
      },
    }),

    alignSelf: 'stretch',
  },

  nextButtonText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.select({
      phone: fontSizeH3,
      tablet: fontSizeH2,
    }),
  },

  pickInfoTitle: {
    ...fontPrimary,
    ...textColorSecondary,
    ...Sizes.select({
      phone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    textAlign: 'center',
    textAlignVertical: 'center',
    marginBottom: Sizes.select({
      phone: 16,
      tablet: 20,
    }),
  },

  profileHeader: {
    width: '100%',
  },
});
